/* eslint-disable react/jsx-props-no-spreading */
const ChevronRight16 = ({
	height = "16px",
	width = "16px",
	fillColor = "#1F8268",
	...props
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 17 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M6.07015 4.21053C5.75428 4.48994 5.75428 4.9413 6.07015 5.22071L9.21265 8.00051L6.07015 10.7803C5.75428 11.0597 5.75428 11.5111 6.07015 11.7905C6.38602 12.0699 6.89627 12.0699 7.21214 11.7905L10.9297 8.50202C11.2456 8.22261 11.2456 7.77125 10.9297 7.49184L7.21214 4.20336C6.90437 3.93111 6.38602 3.93111 6.07015 4.21053Z"
			fill={fillColor}
		/>
	</svg>
);

export default ChevronRight16;
